module.exports = __webpack_public_path__ + "static/media/banner_escritorio.1cae9af2.png";